import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { AppInfoService } from '@shared/services/common/app-info.service';
import { ReportModel } from '@shared/models/report-model';
import { NodeModel } from '@shared/models/node-model';
import { report } from 'process';

@Injectable({
    providedIn: 'root'
})
export class ReportService {

    constructor(public appInfo: AppInfoService, private http: HttpClient) {

    }


    reportDesignerActions(reportId, userId): Observable<any> {
        //'api/ReportDesigner/ReportDesignerActions?Id={reportId}&uId={userId}'
        return this.http.post(this.appInfo.appUrl + `api/ReportDesigner/ReportDesignerActions?Id=${reportId}&uId=${userId}`, this.appInfo.httpOptions);
    }

    //  getDesignerModelAction = "api/ReportDesigner/GetReportDesignerModel";
    getDesignerModelAction(reportUrl): Observable<any>  {
        return this.http.post(this.appInfo.appUrl + `api/ReportDesigner/GetReportDesignerModel`,reportUrl, this.appInfo.httpOptions)
    }

    saveNode(node): Observable<NodeModel> {
        return this.http.post<NodeModel>(this.appInfo.appUrl + "api/report/savereportnode", JSON.stringify(node), this.appInfo.httpOptions);
    }

    getParentNodes() {

        return this.http.get(this.appInfo.appUrl + "api/report/getparentnodes", this.appInfo.httpOptions);
    }

    getDashboardChart(userId, processName, delegatedUserId) {

        let params = new HttpParams().set("userId", userId).set("processName", processName).set("delegatedUserId", delegatedUserId);
        return this.http.get<NodeModel>(this.appInfo.appUrl + "api/report/getdashboardchart", { params: params });
    }

    getNodeById(id): Observable<NodeModel> {
        let params = new HttpParams().set("id", id);

        return this.http.get<NodeModel>(this.appInfo.appUrl + "api/report/getnodebyid", { params: params });
    }

    saveReport(report): Observable<ReportModel> {
        return this.http.post<ReportModel>(this.appInfo.appUrl + "api/report/savereport", JSON.stringify(report), this.appInfo.httpOptions);
    }

    saveReportImport(reportJson): Observable<any> {
        return this.http.post<any>(this.appInfo.appUrl + "api/report/savereportimport", JSON.stringify(reportJson), this.appInfo.httpOptions);
    }

    getReportType(id): Observable<any> {
        let params = new HttpParams().set("id", id);

        return this.http.get<any>(this.appInfo.appUrl + "api/report/getreporttype", { params: params });
    }
    getReport(id): Observable<any> {
        let params = new HttpParams().set("id", id);

        return this.http.get<any>(this.appInfo.appUrl + "api/report/getreport", { params: params });
    }
    updateReportType(_reportId, _reportType, _reportTypeAll, _localeRule): Observable<Boolean> {
        let report = { reportId: _reportId, reportType: _reportType, reportTypeAll: _reportTypeAll, localeRule: _localeRule };
        return this.http.post<Boolean>(this.appInfo.appUrl + "api/report/savereporttype", JSON.stringify(report), this.appInfo.httpOptions);
    }

    getAllReports() {
        return this.http.get(this.appInfo.appUrl + "api/report/getallreports", this.appInfo.httpOptions);
    }


    reportExport(reportId) {
        let params = new HttpParams().set("id", reportId);
        return this.http.get(this.appInfo.appUrl + "api/report/reportExport", { params: params });
    }

    reportFileControl(formData): Observable<string> {
        return this.http.post<string>(this.appInfo.appUrl + "api/report/reportfilecontrol", JSON.stringify(formData), this.appInfo.httpOptions);
    }

    getReportWithoutCategory(lang: string) {
        return this.http.get(this.appInfo.appUrl + "api/report/getreportwithoutcategory?lang=" + lang, this.appInfo.httpOptions);
    }

    getWhitePageReportsWhitUserLang(lang: string) {
        return this.http.get(this.appInfo.appUrl + "api/report/getwhitepagereports?lang=" + lang, this.appInfo.httpOptions);
    }

    getReports() {
        let params = new HttpParams().set("userId", this.appInfo.currentUser.id);

        return this.http.get(this.appInfo.appUrl + "api/report/getreports", { params: params });
    }

    getReportById(id): Observable<ReportModel> {
        let params = new HttpParams().set("id", id);

        return this.http.get<ReportModel>(this.appInfo.appUrl + "api/report/getreportbyid", { params: params });
    }

    getReportStorage(reportId, reportType) {
        let params = new HttpParams().set("reportId", reportId).set("reportType", reportType);

        return this.http.get(this.appInfo.appUrl + "api/report/getreportstorage", { params: params });
    }

    getReportDataExtraColumns(reportId) {
        let params = new HttpParams().set("reportId", reportId);

        return this.http.get(this.appInfo.appUrl + "api/report/getreportdataextracolumns", { params: params });
    }

    getReportDataFormat(reportId) {
        let params = new HttpParams().set("reportId", reportId);

        return this.http.get(this.appInfo.appUrl + "api/report/getreportdataformat", { params: params });
    }

    updateReportStorage(reportId, reportType, storage, datafilter, dataformat, sumColumn) {
        //let params = new HttpParams().set("reportId", reportId).set("reportType", reportType).set("storage", storage).set("dataFilter", datafilter)
        //     .set("dataFormat", dataformat).set("sumColumn", sumColumn);

        let report = { reportId: reportId, reportType: reportType, storage: storage, dataFilter: datafilter, dataFormat: dataformat, sumColumn: sumColumn };
        return this.http.post<Boolean>(this.appInfo.appUrl + "api/report/updatereportstorage", JSON.stringify(report), this.appInfo.httpOptions);

        // return this.http.get(this.appInfo.appUrl + "api/report/updatereportstorage", { params: params });
    }

    deleteNode(id) {
        let params = new HttpParams().set("id", id);

        return this.http.get(this.appInfo.appUrl + "api/report/deletenode", { params: params });
    }

    deleteReport(id) {
        let params = new HttpParams().set("id", id);

        return this.http.get(this.appInfo.appUrl + "api/report/deletereport", { params: params });
    }

    updateEditMode(id) {
        let params = new HttpParams().set("id", id);

        return this.http.get(this.appInfo.appUrl + "api/report/updateeditmode", { params: params });
    }
    errorHandler(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }
    getPdfAndUpload(url: string, pdfName: string, userId: number, reportId: number) {
        let data = { url: url, pdfName: pdfName, userId: userId, reportId: reportId };
        return this.http.post<Boolean>(this.appInfo.appUrl + "api/report/getpdfandupload", JSON.stringify(data), this.appInfo.httpOptions);
    }
}
